import React from 'react'
import "./Rocket_turtle.css"
import { IoIosArrowRoundForward } from "react-icons/io";
import rck_1 from "../Assets/rckt_1.png"
import rck_2 from "../Assets/rckt_2.png"
import left from "../Assets/left_star.png"
import right from "../Assets/right_star.png"
import l_roc from "../Assets/left_roc.png"
import r_roc from "../Assets/r_roc.png"
import bs from "../Assets/bottom_star.png"
import Pdf from '../Assets/whitepaper.pdf';



export default function Rocket_turtle() {
    return (
        <section className='rocket_turt overflow-hidden' id='ABOUT'>
            <div className="container">
            <div data-aos="fade-up">

          
                <h1 className='section_head text-center text-white gor_font' style={{ WebkitTextStroke: "0" }}> Use Rabbits token to purchase NFTs and enjoy high rewards by usdt <br />daily, every day for a year!
                </h1>
                <div className='d-flex mt-5 gap-3 justify-content-center'>
                <a href = {Pdf}  target = "_blank" className='text-decoration-none text-white'> <button className='connect_wallet w-240 text-white nor_font'>WHITEPAPER <IoIosArrowRoundForward className=' text-white fs-2' /> </button></a>
                    {/* <button className='Red_btn nor_btn w-240'>AUDIT</button> */}
                </div>
                </div>
                <div className="row z-2 position-relative justify-content-between  align-items-center rok_ro" >
                    <div className="col-md-6 order-1 order-md-0" data-aos="fade-right">
                        <div className="rkt_cont">
                            <h5 className='gor_font text-white fw-bold fs-1'>PURCHASE NFTs</h5>
                            <p className='fs-5 nor_font ' >Our NFTs are limited to 10,000 per year. Initially, only the team can create these NFTs. Afterward, investors can buy and sell them on the marketplace. Each NFT offers different reward rates, with rarer NFTs providing higher rewards.
                            Each NFT offers different reward rates, with rarer NFTs providing higher rewards.</p>
                            {/* <button className='Red_btn nor_font'>BUY NOW <IoIosArrowRoundForward className=' text-white fs-2' /> </button> */}
                        </div>
                    </div>
                    <div className="col-md-6  order-0 order-md-1 d-flex justify-content-center mt-3 mt-md-0" data-aos="fade-left">
                        <img src={rck_1} className='turtle_img' alt="" />
                    </div>
                </div>
                <div className="row align-items-center justify-content-between z-2 position-relative" style={{marginTop:"3rem"}}>
                   
                    <div className="col-md-6" data-aos="fade-right"  data-aos-duration="1400">
                        <img src={rck_2} className='turtle_img ' alt="" />
                    </div>
                    <div className="col-md-6 mt-3 mt-md-0" data-aos="fade-left"  data-aos-duration="1600">
                        <div className="rkt_cont">
                            <h5 className='gor_font text-white fw-bold fs-1'>Why should you invest in Rabbits?</h5>
                            <p className='fs-5 nor_font ' >Simply put, we're not just another cryptocurrency. We've built an ecosystem that keeps our currency always flying to the moon! 🌕

Once you buy Rabbits, you start receiving daily rewards in USDT at a rate of 6%. 💸 All you have to do is hold it in your wallet. 🏦

And if you want to double your rewards, you can purchase an NFT from our marketplace. 🎨 There are several types of NFTs:

NFT x2 doubles your rewards twice ✌️
NFT x3 triples them 💎
NFT x4 quadruples them 🎯.</p>
<a href="https://x.com/RabbitsNETWORK" target="_blank"    >   <button className='Red_btn nor_font'>Join twitter<IoIosArrowRoundForward className=' text-white fs-2' /> </button> </a>
                        </div>
                    </div>
                </div>
            </div>

            <img src={left} className='left_star' alt="" />
            <img src={right} className='right_star' alt="" />
            <img src={l_roc} className='d-none d-md-block l_roc' alt="" />
            <img src={r_roc} className='d-none d-md-block r_roc' alt="" />
            <img src={bs} className='bs_img' style={{left:"3%"}} alt="" />
            <img src={bs} className='bs_img' style={{right:"3%"}} alt="" />
        </section>
    )
}
